<template>
    <div>
        <button class="button input-button" @click="openDatePicker">
            {{ formatDate }}
        </button>
        <div class="modal" :class="{'is-active': isOpen}">
            <div class="modal-background" @click="closeDatePicker"/>
            <div class="modal-content datepicker">
                <h3 class="calendar-header is-size-6">{{ mode }}</h3>
                <div class="grid-date" v-if="mode === 'year'">
                    <button
                        v-for="year in years"
                        :key="year"
                        @click="pickYear(year)"
                        class="button"
                        :disabled="validateYear(year)">
                        {{ year }}
                    </button>
                </div>
                <div class="grid-date" v-if="mode === 'month'">
                    <button
                    v-for="month in months"
                    :key="month"
                    @click="pickMonth(month)"
                    :disabled="validateMonth(month)"
                    class="button">
                        {{ transformMonthToText(month) }}
                    </button>
                </div>
                <div class="grid-day" v-if="mode === 'day'">
                    <button
                        v-for="day in days"
                        :key="day.ts"
                        @click="pickDay(day.c.day)"
                        :disabled="day.c.month !== pickedDate.month || validateDay(day.c.day)"
                        class="button">
                        {{ day.c.day }}
                    </button>
                </div>
                <button
                 v-if="mode !== 'year'"
                 @click="previousMode"
                 class="button calendar-back">
                    back
                </button>
            </div>
        </div>
    </div>
</template>

<script>
import { DateTime, Interval, Duration } from 'luxon';
import { mapActions } from 'vuex';

export default {
    data() {
        return {
            isOpen: false,
            mode: 'year',
            years: [],
            months: [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12],
            days: [],
            pickedDate: {
                day: 1,
                month: 1,
                year: 2014,
            },
        };
    },
    props: {
        date: {
            type: Date,
            required: true,
        },
        from: {
            type: Date,
            default: () => DateTime.fromISO('2014-01-01').toJSDate(),
        },
    },
    computed: {
        formatDate() {
            return DateTime.fromJSDate(this.date).toFormat('dd/MM/yyyy');
        },
    },
    methods: {
        ...mapActions('track', ['clearMarker']),

        updateDate() {
            this.$emit('updateDate', DateTime.fromObject(this.pickedDate).toJSDate());
        },
        setupYears() {
            const currentYear = DateTime.now().year;
            const START_CALENDAR_DATE = 2014;
            const yearsArray = [];

            for (let i = 0; i <= currentYear - START_CALENDAR_DATE; i += 1) {
                yearsArray.push(START_CALENDAR_DATE + i);
            }

            this.years = yearsArray;
        },
        setupMonthDays() {
            const startMonthWeek = DateTime.fromObject(this.pickedDate).startOf('week');
            const endMonthWeek = DateTime.fromObject(this.pickedDate).endOf('month').endOf('week');
            const intervalMonth = Interval.fromDateTimes(startMonthWeek, endMonthWeek);
            this.days = intervalMonth.splitBy(Duration.fromObject({ days: 1 }))
                .map(interval => interval.s);
        },
        closeDatePicker() {
            this.mode = 'year';
            this.isOpen = false;
            this.pickedDate = {
                day: 1,
                month: 1,
                year: 2014,
            };
        },
        openDatePicker() {
            this.isOpen = true;
            this.clearMarker();
        },
        transformMonthToText(month) {
            const date = DateTime.fromObject({ ...this.pickedDate, month });
            return date.toFormat('MMM');
        },
        previousMode() {
            if (this.mode === 'month') {
                this.mode = 'year';
            } else if (this.mode === 'day') {
                this.mode = 'month';
            }
        },
        pickYear(year) {
            this.mode = 'month';
            this.pickedDate.year = year;
        },
        pickMonth(month) {
            this.pickedDate.month = month;
            this.setupMonthDays();
            this.mode = 'day';
        },
        pickDay(day) {
            this.pickedDate.day = day;
            this.updateDate();
            this.closeDatePicker();
        },
        validateYear(year) {
            return DateTime.fromJSDate(this.from) >= DateTime.fromObject({ year: year + 1 });
        },
        validateMonth(month) {
            return (DateTime.fromObject({ year: this.pickedDate.year, month }) > DateTime.now())
            || (DateTime.fromJSDate(this.from) >= DateTime.fromObject({
                year: this.pickedDate.year, month: month + 1,
            }));
        },
        validateDay(day) {
            return (DateTime.fromObject({ ...this.pickedDate, day }) > DateTime.now())
            || (DateTime.fromJSDate(this.from) >= DateTime.fromObject({
                ...this.pickedDate, day: day + 1,
            }));
        },
    },

    mounted() {
        this.setupYears();
    },
};
</script>
